var d = function(svgFile) {
    return function() {
        return { templateUrl: '/assets/built/app/components/svg/' + svgFile + '.svg' };
    }
};

angular.module('app')
    .directive('svgAbout', d('about'))
    .directive('svgBlockQuote', d('blockQuote'))
    .directive('svgChevronDown', d('chevronDown'))
    .directive('svgChevronUp', d('chevronUp'))
    .directive('svgCoachingReport', d('coachingReport'))
    .directive('svgCustom', d('custom'))
    .directive('svgCustomReport', d('customReport'))
    .directive('svgDevelopmentReport', d('developmentReport'))
    .directive('svgHamburger', d('hamburger'))
    .directive('svgInterviewGuide', d('interviewGuide'))
    .directive('svgInterviewGuideAlt', d('interviewGuideAlt'))
    .directive('svgLeadershipReport', d('leadershipReport'))
    .directive('svgLogo', d('logo'))
    .directive('svgLogoSolid', d('logoSolid'))
    .directive('svgPricing', d('pricing'))
    .directive('svgReports', d('reports'))
    .directive('svgSalesReport', d('salesReport'))
    .directive('svgSteeringWheel', d('steeringWheel'))
    .directive('svgLinkedIn', d('linkedIn'))
    .directive('svgDownload', d('download'))
    .directive('svgLoading', d('loading'))
    .directive('svgArticle', d('article'))
    .directive('svgDollar', d('dollar'));
